import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BookOpen } from "lucide-react";
import api from "@/lib/api";
import { GUIDE_IMG, MEDIA } from "@/lib/media";

export default function Guides() {
  const [guides, setGuides] = useState([]);
  useEffect(() => { api.get("/guides").then((r) => setGuides(r.data)).catch(() => {}); }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-12">
      <div className="max-w-2xl">
        <span className="inline-flex items-center gap-2 rounded-full bg-rose/40 px-4 py-1.5 text-sm font-semibold text-plum">
          <BookOpen className="h-4 w-4 text-teal" /> Guides & Resources
        </span>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl text-plum">Learn with confidence</h1>
        <p className="mt-3 text-mutedplum text-lg">Cornerstone guides written for women 45+—clear, kind and practical. Every guide includes a health note.</p>
      </div>

      <h2 className="mt-12 font-display text-2xl text-plum">Browse all guides</h2>
      <div className="mt-6 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {guides.map((g, i) => (
          <motion.div key={g.slug} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: (i % 3) * 0.08 }}>
            <Link to={`/guides/${g.slug}`} data-testid={`guides-card-${g.slug}`}
              className="group block bg-white rounded-3xl border border-rose/30 shadow-card overflow-hidden hover:-translate-y-1 hover:shadow-soft transition-[transform,box-shadow] duration-300 h-full">
              <div className="h-48 overflow-hidden">
                <img src={GUIDE_IMG[g.image_key] || MEDIA.hero} alt={g.title}
                  className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-6">
                <h3 className="font-display text-xl text-plum leading-snug group-hover:text-teal transition-colors">{g.title}</h3>
                <p className="mt-2 text-[15px] text-mutedplum line-clamp-3">{g.subtitle}</p>
                <span className="mt-4 inline-block text-teal font-semibold text-sm">Read guide →</span>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
